import { network } from 'services/network';

import { QueryFnResponse, QueryParams } from 'api/queries/getTopDurationOverrunRisk.query';

export const ENDPOINT = 'api/bo/getTopOverrunActivities';
export const getTopOverrunActivities = (params: QueryParams) => {
    return network.post<QueryFnResponse>(ENDPOINT, params).then((response) => response.data);
};
